import { updateSavedItem as updateSavedItemUsingSdk } from "../../../../../services/savedItems";
import updateItemSuccess from "./updateItemSuccess";
import { ServiceError } from "../../../../../services/errors";
import {
  UPDATE_ITEM,
  UPDATE_ITEM_FAILURE,
  PURGE_DUPLICATE_SAVED_ITEM
} from "../../constants";
import { ERROR } from "../../../common/constants";
import { StatusCodes } from "http-status-codes";

export default async (dispatch, id, variantId) => {
  let response;

  try {
    response = await updateSavedItemUsingSdk(id, variantId);
  } catch (e) {
    if (e instanceof ServiceError) {
      dispatch({
        type: UPDATE_ITEM_FAILURE,
        payload: { id }
      });

      dispatch({
        type: ERROR,
        payload: {
          id,
          failedActionType: UPDATE_ITEM,
          canBeRetried: false
        }
      });
    }

    throw e;
  }

  if (response === null) {
    return null;
  }

  if (response.status === StatusCodes.RESET_CONTENT) {
    dispatch({
      type: PURGE_DUPLICATE_SAVED_ITEM,
      payload: { id, variantId }
    });
  }

  return dispatch(updateItemSuccess({ id }));
};
